import { render, staticRenderFns } from "./InputCEP.vue?vue&type=template&id=4dbf58da&scoped=true"
import script from "./InputCEP.vue?vue&type=script&lang=js"
export * from "./InputCEP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf58da",
  null
  
)

export default component.exports